import React, { useState, useEffect } from 'react'
import { MapContainer, TileLayer, LayersControl } from 'react-leaflet'
import config from '../../config/BaseMapConfig'
import 'leaflet/dist/leaflet.css'
import '../../style/BaseMapStyle.css'
import RegionsGeoJSON from '../../data/geojson/borders.json'
import Regions from './Regions'
import CustomTileLayer from './CustomTileLayer'
import HomePanel from './HomePanel'
import Header from '../Header/InfoHeader'


const BaseMap = (props) => {
  const {
    prognoseFogHeights,
    // setPrognoseFogHeights,
    date,
    setDate,
    lastUpdated,
    usePrognose,
    setUsePrognose,
  } = props

  const [swissCenter, setSwissCenter] = useState(config.swiss_center);
  const [zoom, setZoom] = useState(config.min_zoom);
  const [regions, setregions] = useState(RegionsGeoJSON.features);
  const [map, setMap] = useState(null);
  const [currentSliderValue, setCurrentSliderValue] = useState(700);
  const [potentialFogTileLayer, setPotentialFogTileLayer] = useState (false);
  const [finalSliderValue, setFinalSliderValue] = useState(700);

  return (
    <div>
      <MapContainer
        center={swissCenter}
        zoom={zoom}
        maxZoom={config.max_zoom}
        minZoom={config.min_zoom}
        scrollWheelZoom
        zoomControl={false}
        ref={setMap}
        style={{ height: `100vh`, fontSize: '14px' }}
        attributionControl
      >
        <HomePanel
          setDate={setDate}
          setUsePrognose={setUsePrognose}
          currentSliderValue={currentSliderValue}
          setCurrentSliderValue={setCurrentSliderValue}
          setFinalSliderValue={setFinalSliderValue}
          setPotentialFogTileLayer={setPotentialFogTileLayer}
        />
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name={config.background_maps.osm_style.name}>
            <TileLayer
              url={config.background_maps.osm_style.tile_url}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={config.background_maps.swiss_style.name}>
            <TileLayer
              url={config.background_maps.swiss_style.tile_url}
            />
          </LayersControl.BaseLayer>


          <Regions
            date={date}
            regions={regions}
            prognoseFogHeights={prognoseFogHeights}
            potentialFogTileLayer={potentialFogTileLayer}
          />
          <CustomTileLayer
            date={date}
            prognoseFogHeights={prognoseFogHeights}
            lastUpdated={lastUpdated}
            usePrognose={usePrognose}
            finalSliderValue={finalSliderValue}
            potentialFogTileLayer={potentialFogTileLayer}
          />
        </LayersControl>
      </MapContainer>
      <Header />
    </div>
  )
}
export default BaseMap
